import React from 'react';
import { ReviewVoteDto } from '@checkfront/guest-experience-api-api-client-javascript-axios';
import Box from '@mui/material/Box';
import { classes } from '@guest-widgets/shared/src/classes';
import { Rating } from '@guest-widgets/shared/src/components/Rating/Rating';
import { styled } from '@mui/material/styles';

import { CategoryTitle } from './CategoryTitle';

export interface RatingCategoriesProps {
  votes: ReviewVoteDto[];
  isStacked?: boolean;
}

export const RatingCategories = ({ votes, isStacked }: RatingCategoriesProps) => {
  if (!isStacked) {
    return (
      <Box
        className={classes.details.reviews.rating.stars}
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        {votes.map((vote, index) => (
          <Box className={classes.details.reviews.rating.category.root} display="flex" key={index}>
            <StackedLabel className={classes.details.reviews.rating.category.label} mr={2}>
              <CategoryTitle label={vote.category} />
            </StackedLabel>
            <Rating value={vote.value * 5} noLabel />
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Grid>
      {votes.map((vote, index) => (
        <React.Fragment key={index}>
          <Label className={classes.details.reviews.rating.category.label}>
            <CategoryTitle label={vote.category} />
          </Label>
          <Stars>
            <Rating value={vote.value * 5} noLabel />
          </Stars>
        </React.Fragment>
      ))}
    </Grid>
  );
};

const StackedLabel = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

const Grid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  gridColumnGap: theme.spacing(3),
}));

const Label = styled('div')(({ theme }) => ({
  gridColumn: 1,
  color: theme.palette.text.primary,
}));

const Stars = styled('div')({
  gridColumn: 2,
});
